import SmsSettings from '@/views/settings/views/SmsSettings.vue';
import EmailSettings from '@/views/settings/views/EmailSettings.vue';
import SecuritySettings from '@/views/settings/views/SecuritySettings.vue';
import GoogleMapSettings from '@/views/settings/views/GoogleMapSettings.vue';
import Companies from '@/views/settings/views/Companies.vue';
import Branches from '@/views/settings/views/Branches.vue';
import DataMigration from '@/views/settings/views/DataMigration.vue';
import Tags from '@/views/settings/views/Tags.vue';

export default [
  {
    path: '/settings/sms_settings/',
    component: SmsSettings,
    //component: () => import('@/views/settings/views/SmsSettings.vue'),
    meta: { 
      requiresPermission: 'sms_settings.view', 
      requiresSubscription: 'sms_settings.view',
      featureName: 'SMS Settings' 
    } 
    //meta: { requiresPermission: 'sms_settings'} 
  },
  {
    path: '/settings/email_settings/',
    component: EmailSettings,
    //component: () => import('@/views/settings/views/EmailSettings.vue'),
    meta: { 
      requiresPermission: 'email_settings.view', 
      requiresSubscription: 'email_settings.view',
      featureName: 'Email Settings' 
    } 
    //meta: { requiresPermission: 'email_settings'} 
  },
  {
    path: '/settings/security_settings/',
    component: SecuritySettings,
    //component: () => import('@/views/settings/views/SecuritySettings.vue'),
    meta: { 
      requiresPermission: 'security_settings.view', 
      requiresSubscription: 'security_settings.view',
      featureName: 'Security Settings' 
    } 
    //meta: { requiresPermission: 'security_settings'} 
  },
  {
    path: '/settings/google_map_settings/',
    component: GoogleMapSettings,
    //component: () => import('@/views/settings/views/GoogleMapSettings.vue'),
    meta: { 
      requiresPermission: 'google_map_settings.view', 
      requiresSubscription: 'google_map_settings.view',
      featureName: 'Google Map Settings'
    } 
    //meta: { requiresPermission: 'google_map_settings'} 
  },
  {
    path: '/settings/companies/',
    component: Companies,
    //component: () => import('@/views/settings/views/GoogleMapSettings.vue'),
    meta: { 
      requiresPermission: 'companies.view', 
      requiresSubscription: 'companies.view',
      featureName: 'Companies' 
    } 
    //meta: { requiresPermission: 'google_map_settings.view'} 
  },
  {
    path: '/settings/branches/',
    component: Branches,
    //component: () => import('@/views/settings/views/GoogleMapSettings.vue'),
    meta: { 
      requiresPermission: 'branches.view', 
      requiresSubscription: 'branches.view',
      featureName: 'Branches' 
    } 
    //meta: { requiresPermission: 'google_map_settings'} 
  },
  {
    path: '/settings/tags/',
    component: Tags,
    meta: { 
      requiresPermission: 'tags.view', 
      requiresSubscription: 'tags.view',
      featureName: 'Tags' 
    } 
  },
  {
    path: '/migrations/data_migration/',
    component: DataMigration,
    meta: { 
      requiresPermission: 'data_migration.view', 
      requiresSubscription: 'data_migration.view',
      featureName: 'Data Migration' 
    } 
    //component: () => import('@/views/subscription/views/SubscriptionRequired.vue')
  }

];
